import React from "react";

const words = [
  "STRATEGISE", "OPTIMISE", "TRANSFORM", "OPERATIONAL EXCELLENCE",
  "SUPPLY CHAIN", "ARTIFICIAL INTELLIGENCE", "DIGITAL TRANSFORMATION",
  "LEADERSHIP", "SUSTAINABLE IMPACT",
];

export const Marquee = ({ dark = false }) => {
  const row = [...words, ...words];
  return (
    <div className={`relative overflow-hidden border-y py-6 ${dark ? "border-white/10 bg-emerald-darkest" : "border-black/5 bg-off-white"}`} data-testid="brand-marquee">
      <div className="flex w-max animate-marquee gap-10">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-serif text-2xl sm:text-3xl italic ${dark ? "text-off-white/80" : "text-emerald-base"}`}>{w}</span>
            <span className="text-gold text-xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
